<div class="script-tag-container">
  <form [formGroup]="formGroup">
    <div class="header">
      <div class="header-title">
        <pdq-heading element="h5">Checkout script</pdq-heading>
      </div>
      <pdq-slide-toggle
        formControlName="scriptTagEnabled"
        [disabled]="shop?.metadata?.scriptTagAddedToHeader"
        [ignoreValueChangeOnToggle]="!formGroup.get('scriptTagEnabled').value"
        (onToggle)="handleToggle($event)"></pdq-slide-toggle>
    </div>

    <div class="content">
      Add PDQ scripts for advanced checkout features (only recommended for non-Shopify Plus stores)
    </div>
  </form>
</div>
